import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';
import { DatePicker, DatePickerTypeView } from 'primeng/datepicker';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

interface DatepickerFieldProps extends FormlyFieldProps {
  timeOnly?: boolean;
  range?: 'single' | 'multiple' | 'range' | undefined;
  showTime?: boolean;
  appendTo?: boolean;
  showOnFocus?: boolean;
  showIcon?: boolean;
  iconDisplay?: 'input' | 'button' | undefined;
  view?: DatePickerTypeView;
  dateFormat?: string;
}

@Component({
  selector: 'calendar-field',
  standalone: true,
  imports: [...FORM_IMPORTS, DatePicker],
  template: `
    <p-datepicker
      class="w-full"
      [formControl]="formControl"
      [formlyAttributes]="field"
      autocomplete="false"
      [placeholder]="props.placeholder"
      [appendTo]="props.appendTo ?? 'body'"
      [timeOnly]="props.timeOnly ?? false"
      [showTime]="props.showTime ?? false"
      [selectionMode]="props.range ?? 'single'"
      [showIcon]="props.showIcon == false ? false : true"
      [iconDisplay]="props.iconDisplay ?? 'input'"
      hourFormat="24"
      [view]="props.view ?? 'date'"
      [dateFormat]="props.dateFormat ?? 'dd/mm/yy'"
    >
      <ng-template #inputicon>
        <i class="fa-regular fa-calendar"></i>
      </ng-template>
    </p-datepicker>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatepickerFieldType extends FieldType<
  FieldTypeConfig<DatepickerFieldProps>
> {}
